import React from "react";
import { Card } from "@sscs/ui";
import { FileTypeIcon } from "Components";
import { ApprovalStatus as ApprovalStatusType } from "Types";
import styles from "./cardTitle.module.scss";

const APPROVAL_TO_STYLES: Record<ApprovalStatusType, string> = {
  ApprovalRejected: styles["title-container-rejected"],
  Approved: styles["title-container-approved"],
  ApprovedAutomatically: styles["title-container-approved"],
  ApprovalRevoked: styles["title-container-revoked"],
  Undetermined: styles["title-container-undetermined"],
};

type CardTitleProps = {
  fileName: string;
  architecture: string;
  approvalStatus?: ApprovalStatusType;
  details?: React.ReactNode[];
  actions?: React.ReactNode;
  children: React.ReactNode;
};

const CardTitle = ({
  fileName,
  architecture,
  approvalStatus,
  details,
  actions,
  children,
}: CardTitleProps): React.JSX.Element => {
  return (
    <Card.Title
      className={approvalStatus && APPROVAL_TO_STYLES[approvalStatus]}
      details={details}
      actions={actions}
    >
      <div className={styles["title-content"]}>
        <FileTypeIcon fileName={fileName} architecture={architecture} />
        <div className={styles.title}>{children}</div>
      </div>
    </Card.Title>
  );
};

export default CardTitle;
